import EffortsTableWithFilters from 'pages/efforts/EffortsTable';

interface Props {
    contactId?: string;
}

const EffortView: React.FC<Props> = ({ contactId }) => {
    if (!contactId) {
        return null;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            <EffortsTableWithFilters
                passiveFilter={`id=iseffortcontact=${contactId}`}
                contactId={contactId}
                disabledFilterIds={['effortForPartyFilter', 'myPortfolioEffortsFilter']}
                disabledGroups={['efforts.filter-groups.contact']}
            />
        </div>
    );
};

export default EffortView;
